import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Carte } from '../interface/carte';
import { first, firstValueFrom } from 'rxjs';
import { DataService } from './data.service';
import { DisableOrActive } from '../interface/disableOrActive';

@Injectable({
  providedIn: 'root'
})
export class CarteService {
  private _isFromMatrix = true;

  URL = `${environment.mkgoURL}/api/v1/menu`;

  constructor(
    private _http: HttpClient,
    private dataService: DataService
  ) { }

  /** @todo test */
  async create(carte: Carte): Promise<any> {
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.post(this.URL, carte, options).pipe(first()).toPromise();
    return resp;
  }

  /** @todo test */
  async get(id: string): Promise<Carte> {
    const url = `${this.URL}/${id}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.get(url, options).pipe(first()).toPromise();
    return resp as Carte;
  }

  async getAll(): Promise<Partial<Carte>[]> {
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp: { menus: {
      _id: string;
      brand: string;
      series: string;
      updatedAt: string;
    }[] } = await this._http.get(this.URL, options).pipe(first()).toPromise() as any;
    return resp.menus;
  }

  async getAllFull(): Promise<Carte[]> {
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp: {
      menus: Carte[]
    } = await this._http.get(this.URL + '/all', options).pipe(first()).toPromise() as any;
    return resp.menus;
  }

  /** @todo test */
  async update(carte: Carte): Promise<any> {
    const url = `${this.URL}/${carte._id}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const apiObject: Carte = {
      brand: carte.brand,
      model: carte.model,
      reviews: carte.reviews,
      series: carte.series,
      markup: carte.markup
    }
    if (carte.osType) {
      apiObject.osType = carte.osType
    }
    const resp = await this._http.put(url, apiObject, options).pipe(first()).toPromise();
    return resp;
  }

  /** @todo test */
  async delete(id: string): Promise<any> {
    const url = `${this.URL}/${id}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.delete(url, options).pipe(first()).toPromise();
    return resp;
  }

  async getInactives(): Promise<Partial<Carte>[]> {
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp: { menuModels: {
      _id: string;
      brand: string;
      series: string;
      updatedAt: string;
    }[] } = await firstValueFrom(this._http.get(`${this.URL}/inactives`, options)) as any;
    return resp.menuModels;
  }

  async inactiveOrActive(id: string, action: DisableOrActive): Promise<any> {
    const url = `${this.URL}/${id}/${action}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const resp = await firstValueFrom(this._http.put(url, {}, options));
    return resp;
  }
}

